const siteHeader = document.getElementById('js-fasten-header');
const activeClass = 'x-fasten-header--is-active';
let animationTimeout = 0;
let lastKnownScrollY = 0;
let currentScrollY = 0;

var pin = function () {
	if (!document.body.classList.contains(activeClass)) {
		document.body.classList.add(activeClass);
	}
};

var unpin = function () {
	if (document.body.classList.contains(activeClass) && !document.documentElement.classList.contains('x-mini-basket--is-open-ios')) {
		document.body.classList.remove(activeClass);
		document.querySelector('.t-main-content-element').classList.remove('t-main-content-element__search-blur');
	}
};

var onScroll = function () {
	let siteHeaderHeight = siteHeader.offsetHeight;
	let position = window.pageYOffset || document.documentElement.scrollTop;
	currentScrollY = window.pageYOffset;

	// Desktop Functionality
	if (window.innerWidth > 960) {
		if (position > siteHeaderHeight) {
			pin();
		} else {
			unpin();
		}
	} else if (currentScrollY < lastKnownScrollY && position > siteHeaderHeight) {
		pin();
	} else if (currentScrollY > lastKnownScrollY || position < siteHeaderHeight) {
		unpin();
	}

	lastKnownScrollY = currentScrollY;
};

if (siteHeader) {
	onScroll();

	window.addEventListener('scroll', function () {
		'use strict';

		if (animationTimeout) {
			window.cancelAnimationFrame(animationTimeout);
		}

		animationTimeout = window.requestAnimationFrame(function () {
			onScroll();
		});
	}, false);
}
